import { useMemo, useState } from "react";
import { homepageMeta } from "./_meta";
import styles from './_videos.module.scss';
import HcpHero from "@/components-hcp/hero";
import HcpLongButton from "@/components-hcp/long-button";
import HcpHearExperience from "./components/hear-experience";
import HcpDrQuote from "@/components-hcp/dr-quote";
import HcpVideoLibrary from "./components/video-library";
import HcpVideoContainer from "./components/video-container";
import HcpPageFootnote from "@/components-hcp/page-footnote";
import HcpPageReferences from "@/components-hcp/page-references";
import HcpVideoCallouts from "./components/callouts";

const doctorData = [
  {
    name: 'Dr. Heidi Shea',
    specialty: <span className="text-hcp-charcoal leading-inherit">Adult & Pediatric Endocrinologist</span>,
    location:  <span className="text-hcp-charcoal leading-inherit">Dallas, TX</span>,
    image: '/images/page/hcp/videos/Videos_Meet-CAH-HCP-Specialist-Dr-Shea.png',
    quote: <>A lot of patients do come in, and they say, ‘Hey, what about this drug?’ <span className="leading-inherit mobile:hidden">&nbsp;</span>This is an exciting opportunity to be able to give them something different, which we didn’t have before.”</>,
    note: '',
    alt: "Click to learn more from Dr. Heidi Shea"
  },
  {
    name: 'Dr. Amrit Bhangoo',
    specialty:  <span className="text-hcp-charcoal leading-inherit">Pediatric Endocrinologist</span>,
    location:  <span className="text-hcp-charcoal leading-inherit">Orange County, CA</span>,
    image: '/images/page/hcp/videos/Videos_Meet-CAH-HCP-Specialist-Dr-Bhangoo.png',
    quote: <>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </>,
    alt: "Click to learn more from Dr. Amrit Bhangoo"
  },
  {
    name: 'Dr. Run Yu',
    specialty:  <span className="text-hcp-charcoal leading-inherit">Adult Endocrinologist</span>,
    location:  <span className="text-hcp-charcoal leading-inherit">Los Angeles, CA</span>,
    image: '/images/page/hcp/videos/Videos_Meet-CAH-HCP-Specialist-Dr-Yu.png',
    quote: <>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </>,
    alt: "Click to learn more from Dr. Run Yu"
  }
]

export default function HcpVideos() {
  const [selection, setSelection] = useState(null); // use with hear-experience to set selection
  const references = useMemo(() => [
    <>Vaid S, Abramowitz J, Bancos I, et al. A cross-sectional survey on crinecerfont and quality of life of adults with classic congenital adrenal hyperplasia in the United States participating in CAHtalyst<sup>®</sup> adult and pediatric open-label extension. Presented at: The Endocrine Society Annual Meeting; June 13-16, 2026; Chicago, IL.</>,
  ], []);

  return (
      <div className={styles.container}>
        <HcpHearExperience
          selection={selection}
          setSelection={setSelection}
          doctorData={doctorData}
        />
        <HcpDrQuote
          theme="tan"
          // doctor={selection === null || selection === "" ? doctorData[0] : doctorData.find(doctor => doctor.name === selection)}
          //mostly doctorData[0] except for image value (orange border on this one not white)
          doctor={{
            ...doctorData[0],
            image: '/images/components/CAH-HCP-Specialist-Dr-Shea.png'
          }}
        >
          {/* {selection === null || selection === "" ? doctorData[0].quote : doctorData.find(doctor => doctor.name === selection)?.quote} */}
          {doctorData[0].quote}
        </HcpDrQuote>
        
        <HcpVideoLibrary 
          videoId={"video-candid-cahnversations"}
          sectionTitle={<>CANDID <strong>CAH</strong>NVERSATIONS</>}
          disclaimer="These physicians have been compensated by Neurocrine for sharing their views."
          thumbAlt="Three CAH HCP specialists - Click to play video"
          videoData={useMemo(() => [
            {
              videoURL: 'https://player.vimeo.com/progressive_redirect/playback/1132563154/rendition/1080p/file.mp4?loc=external&signature=e17e9cff72acc3c8fb40a70f60d2b10f5219ccc3cde3e0c67f3451d5a5b61f3b',
              thumbnailSrc: '/images/page/hcp/videos/Videos_Meet-CAH-HCP-Specialists-Video-Thumbnail-1.jpg',
              title: 'Impact of CRENESSITY',
              description: <>These experts discuss the challenges of managing CAH with GCs alone and share how CRENESSITY helps optimize treatment, potentially leading to better patient outcomes.</>,
              preTitle: 'Candid CAHnversations',
              anchor: "impact-of-crenessity",
              label: "Video Libray List - Impact of Crenessity",
              caption: "/images/page/hcp/videos/captions/CRENESSITY_IMPACT-OF-CRENESSITY.vtt",
            },
            {
              videoURL: 'https://player.vimeo.com/progressive_redirect/playback/1132561952/rendition/1080p/file.mp4?loc=external&signature=4f72fb1a895ab57bbc5bcf65576700e75945825f6175d80e655176346a666f8d',
              thumbnailSrc: '/images/page/hcp/videos/Videos_Meet-CAH-HCP-Specialists-Video-Thumbnail-2.jpg',
              title: 'GC Down-Titration',
              description: <>Explore GC reduction strategies, key clinical considerations, and the importance of ongoing patient monitoring. </>,
              preTitle: 'Candid CAHnversations',
              anchor: "gc-down-titration",
              label: "Video Libray List - GC Down-Titration",
              caption: "/images/page/hcp/videos/captions/CRENESSITY_GC-DOWN-TITRATION.vtt",
            },
            {
              videoURL: 'https://player.vimeo.com/progressive_redirect/playback/1132559463/rendition/1080p/file.mp4?loc=external&signature=9bcaed083ef0a1c7fb7138bd0926978d086ee9667f1507c330ea7f9befe8248f',
              thumbnailSrc: '/images/page/hcp/videos/Videos_Meet-CAH-HCP-Specialists-Video-Thumbnail-3.jpg',
              title: 'Who May Benefit From CRENESSITY',
              description: <>CAH specialists discuss the range of patients they consider appropriate for treatment with CRENESSITY. </>,
              preTitle: 'Candid CAHnversations',
              anchor: "who-may-benefit-from-crenessity",
              label: "Video Libray List - Who May Benefit From Crenessity",
              caption: "/images/page/hcp/videos/captions/CRENESSITY_WHO-MAY-BENEFIT.vtt",
            },
            {
              videoURL: 'https://player.vimeo.com/progressive_redirect/playback/1132560390/rendition/1080p/file.mp4?loc=external&signature=ad557ce8705c7e9b0f109b547256e17c1f481aa9e381e685982d29d90c167e1c',
              thumbnailSrc: '/images/page/hcp/videos/Videos_Meet-CAH-HCP-Specialists-Video-Thumbnail-4.jpg',
              title: 'Initiating CRENESSITY',
              description: <>Experts describe how they introduced the option of starting CRENESSITY and how it could help their patients meet specific treatment goals. </>,
              preTitle: 'Candid CAHnversations',
              anchor: "initiating-crenessity",
              label: "Video Libray List - Initiating Crenessity",
              caption: "/images/page/hcp/videos/captions/CRENESSITY_INITIATING-CRENESSITY.vtt",
            }
          ], [])} 
        />
        <HcpVideoLibrary
          videoId="video-clinical-profiles"
          sectionTitle={<>CLINICAL PROFILES FROM THE <strong>CAH</strong>TALYST<sup>&reg;</sup> TRIALS</>}
          disclaimer="Ambassadors were compensated by Neurocrine for sharing their views."
          thumbAlt="Clinical profiles - Click to play video"
          videoData={useMemo(() => [
            {
              videoURL: 'https://player.vimeo.com/progressive_redirect/playback/1113600687/rendition/1080p/file.mp4?loc=external&signature=703a3d60d33309ae728e36989c11df12c1e97368d19bdd932c7cb55221bf505d',
              thumbnailSrc: '/images/page/hcp/videos/Videos_Clinical-Profiles-Video-Thumbnail-Grant-and-Kristy.png',
              title: 'Kristy & Grant',
              description: <span className="text-hcp-charcoal leading-inherit">Kristy shares her son Grant’s experience with CRENESSITY during the clinical trial—and beyond—including how much his androgen levels and GC dose dropped.</span>,
              preTitle: 'Clinical Profiles',
              anchor: 'kristy-grant',
            },
            {
              videoURL: 'https://player.vimeo.com/progressive_redirect/playback/1113604617/rendition/1080p/file.mp4?loc=external&signature=cb36b8a1df9c8883539db3d9931efc009527ac3a581e169f2ed4d547b9e163d7',
              thumbnailSrc: '/images/page/hcp/videos/Videos_Clinical-Profiles-Video-Thumbnail-Susan.png',
              title: 'Susan',
              description: <span className="text-hcp-charcoal leading-inherit">Hear Susan’s treatment journey, from taking high doses of GCs and experiencing related side effects to starting CRENESSITY and achieving lower androgens along with reduced GC doses.</span>,
              preTitle: 'Clinical Profiles',
              anchor: 'susan',
            },
            {
              videoURL: 'https://player.vimeo.com/progressive_redirect/playback/1113603823/rendition/1080p/file.mp4?loc=external&signature=05ed7a7393fee6b2cb36fc0fa6b789a1e1e25ce4942064a5b7645620db074de3',
              thumbnailSrc: '/images/page/hcp/videos/Videos_Clinical-Profiles-Video-Thumbnail-Paul.png',
              title: 'Paul',
              description: <span className="text-hcp-charcoal leading-inherit">Paul explains how taking CRENESSITY during and after the adult clinical trial helped him reach his treatment goals and why he would recommend CRENESSITY to others living with classic CAH.</span>,
              preTitle: 'Clinical Profiles',
              anchor: 'paul',
            },
            {
              videoURL: 'https://player.vimeo.com/progressive_redirect/playback/1113602533/rendition/1080p/file.mp4?loc=external&signature=8942b7bcf0c989b239eed40210568215c47e5dbc3a4382535ab6ba0a4d3cab38',
              thumbnailSrc: '/images/page/hcp/videos/Videos_Clinical-Profiles-Video-Thumbnail-Liam.png',
              title: 'Liam',
              description: <span className="text-hcp-charcoal leading-inherit">Hear how, after taking CRENESSITY, Liam’s CAH lab results improved, he was able to lower his GC doses, and his outlook on the future changed.</span>,
              preTitle: 'Clinical Profiles',
              anchor: 'liam',
            }
          ], [])}
        />
        <HcpVideoCallouts />
        <HcpDrQuote
          doctor={null}
          theme="lilac"
        >
          Having the ability to be on less steroids provides peace of mind.”<span className="font-extralight"> — Participant from Adult CAHtalyst<sup>®</sup> trial at the end of the open-label extension period</span>
        </HcpDrQuote>
        <HcpVideoContainer
          sectionTitle={<>SCIENCE OF CRENESSITY</>}
          videoURL='https://player.vimeo.com/progressive_redirect/playback/1055781182/rendition/1080p/file.mp4?loc=external&signature=c2ddfd805dbcb44e2fecee54a55f24ec672d4c5af1b5de089b15fe292878aa68'
          thumbnailSrc='/images/page/hcp/videos/Videos_MOA-Video-Thumbnail.png'
          title='Mechanism of Action'
          alt="Mechanism of action - Click to play video"
          description={<span className="text-hcp-charcoal leading-inherit">Watch the video to learn more about how CRENESSITY works in the CRF pathway.</span>}
          label="MOA Video Play Button"
          caption="/images/page/hcp/videos/captions/CFT-HCP-MOA-Video.vtt"
        />
        <section>
          <HcpLongButton
            iconType="Dosing-Schedule"
            label={<>Dosing</>}
            hideDropShadow
            description={<span className="inline-block max-w-[500px]">Review the dosing and administration information for CRENESSITY.</span>}
            href="/dosing"
          />
          <HcpLongButton
            iconType="Support"
            label={<>Support & Resources</>}
            hideDropShadow
            description={<span className="inline-block max-w-[500px]">Review dedicated support for you and your patients.</span>}
            href="/support-resources"
          />
        </section>
        <HcpPageFootnote>
          CAH=congenital adrenal hyperplasia; CRF=corticotropin-releasing factor; GC=glucocorticoid.
        </HcpPageFootnote>
        <HcpPageReferences references={references} />
      </div>
  );
}

HcpVideos.getLayoutProps = (_pageProps, _router) => ({
  customClass: styles.layout,
  meta: homepageMeta,
  hero: (
    <HcpHero
      // theme="peach"
      backgroundImageSrc="/images/page/hcp/support/support-hero-gradient-bg.jpg"
    >
      <span className="mt-2 mb-8 mobile-down:mb-0 mobile-down:mt-0 inline-block">
        REAL EXPERIENCES OF EXPERTS AND PATIENTS
      </span>
    </HcpHero>
  ),
});